/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const Bar = (props) => {
  const getOption = () => {
    let option = {
      interval: props.graphprops.bar ? props.graphprops.bar['Interval'] : '',
      legend: {
        textStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect'
          }
        ]
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            title: 'download',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops,
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          },
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          interval: 0,
          rotate: 90
        }
      },
      grid: {},
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,

          backgroundColor: '#9a9191',
          textStyle: {
            color: 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };
    return option;
  };
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(dayjs());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    translationCache,
    currentTimeZone
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);

  const removeDuplicateObjectsByKey = (array, fieldToDuplicateCheck) => {
    const newArray = [];
    const arrayKeys = [];
    array.forEach((item) => {
      if (!arrayKeys.includes(item[fieldToDuplicateCheck])) {
        arrayKeys.push(item[fieldToDuplicateCheck]);
        newArray.push(item);
      }
    });
    return newArray;
  };
  const translateYAxisTags = (yAxisConfig, translationCache) => {
  return yAxisConfig.map(axis => {
    axis.tags = axis.tags.map(tag => {
      if (translationCache[tag]) {
        return translationCache[tag];
      }
      return tag; 
    });

    return axis; 
  });
};
  const addYAxisIndex = (data, config) => {
    const yAxisConfig = JSON.parse(config.YAxis);
    const translatedYAxisConfig = translateYAxisTags(yAxisConfig, translationCache);

    const tagsToIndex = {};

    translatedYAxisConfig.forEach((axis, idx) => {
      axis.tags.forEach(tag => {
        tagsToIndex[tag] = idx;
      });
    });
    
    data.forEach(entry => {
      if (entry.name) {
        if (tagsToIndex[entry.name] !== undefined) {
          entry.yAxisIndex = tagsToIndex[entry.name];
        }
      }
    });


    return data;
  }
  const getData = async (props) => {
    requestCheck.current = false;
    let errorInAPI = false;
    let noDataInDB = false;
    let json = [];
    let { graphprops } = props;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck = true;
    } else {
      if (props.graphprops.graph === 'rangeBar' && props.graphprops.currentDateData !== undefined) {
        json = props.graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            ...(DeviceCode ? { DeviceCode } : {}),
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            ...(DeviceCode ? { DeviceCode } : {}),
            TimeZone: currentTimeZone,
          });
          requestCheck = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      let dates = [];
      let values = [];
      let name = '';
      let Names = [];
      let seriesarray = [];
      let legendsdata = [];
      let showLabel = false;
      let showStack = false;
      let formatted = false;
      let gridIndex = false;
      let viewType = '';

      let { graphprops } = props;
      if (graphprops && graphprops.bar && graphprops.bar['showLabel']) {
        showLabel = graphprops.bar['showLabel'] || false;
      }
      if (graphprops && graphprops.bar && graphprops.bar['showStack']) {
        showStack = graphprops.bar['showStack'] || false;
      }
      if (graphprops && graphprops.bar && graphprops.bar['formatted']) {
        formatted = graphprops.bar['formatted'] || false;
      }
      if (graphprops && graphprops.bar && graphprops.bar['viewType']) {
        viewType = graphprops.bar['viewType'] || 'vertical';
      }
      if (graphprops && graphprops.bar && graphprops.bar['gridIndex']) {
        gridIndex = graphprops.bar['gridIndex'] || false;
      }
      const labelOption = {
        show: true,
        position: 'insideBottom',
        distance: 15,
        align: 'left',
        verticalAlign: 'middle',
        rotate: 90,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {}
        }
      };

      let descriptionList = [];
      json &&
        Array.isArray(json) &&
        json.map((val) => {
          if (val.Description && val.Description !== name) {
            if (Names.indexOf(val.Description) === -1) {
              Names.push(val.Description);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: props.theme.algorithm === "dark" ? 'white' : 'black',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
              descriptionList = [...descriptionList, val.Description];
            }
          }
          return {};
        });
      let descriptionListDuplicate = [];
      descriptionListDuplicate = removeDuplicateObjectsByKey(descriptionList, 'Name');

      let yAxisData = [];
      if (
        props &&
        props.graphprops &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].YAxis
      ) {
        let jsonValue =
          props &&
          props.graphprops &&
          props.graphprops[props.graphprops.graph] &&
          props.graphprops[props.graphprops.graph].YAxis;
        yAxisData = jsonValue ? JSON.parse(jsonValue) : [];
      } else {
        yAxisData = [];
      }

      let yaxis = yAxisData && Array.isArray(yAxisData) && yAxisData.map((value, index) => {
        let axis = {};
        axis.splitLine = {
          show: false,
          lineStyle: {
            color: '#504c4c'
          }
        };
        axis.triggerEvent = true;
        axis.axisLine = {
          show: true,
          lineStyle: {
            color:
              props.graphprops &&
                props.graphprops[props.graphprops.graph] &&
                props.graphprops[props.graphprops.graph].colors &&
                props.graphprops[props.graphprops.graph].colors[index] !== undefined
                ? value && value.tags && value.tags.length > 1
                  ? 'white'
                  : props.graphprops &&
                  props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].colors &&
                  props.graphprops[props.graphprops.graph].colors[index]
                : 'white'

          }
        };
        axis.max = value.max;
        axis.min = value.min;
        axis.offset = value.offset;
        axis.interval = value.interval;
        axis.position = value.position;
        axis.name = value.name;
        axis.tags = value.tags;
        return axis;
      });
      if (
        props &&
        props.graphprops &&
        props.graphprops.title !== 'Cylinder Force vs Retracting  & Extending Time' &&
        props.graphprops.title !== 'Power Generation' &&
        props.graphprops.title !== 'Power Generation Previous Day'
      ) {
        yaxis && yaxis.unshift({
          splitLine: {
            show: false,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            show: true,
            lineStyle: {
              color:
                props.graphprops &&
                  props.graphprops.bar &&
                  props.graphprops.bar.Linecolor &&
                  props.graphprops.bar.Linecolor.length > 0
                  ? props.graphprops.bar.Linecolor[0]
                  : 'white'
            }
          },
          axisLabel: { fontSize: 15 },
          tags: []
        });
      }

      Names.map((tagval, tagindex) => {
        values = [];
        json.map((jsonval) => {
          if (Names[0] === jsonval.Description && tagindex === 0) {
            let date = {};
            if (
              props.graphprops.monthExists === 'true' ||
              props.graphprops.monthExists === true
            ) {
              date =
                graphprops && graphprops.type === 'live'
                  ? dayjs.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYY')
                  : dayjs(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYYY');
            } else {
              if (
                graphprops &&
                graphprops.bar &&
                graphprops.bar.XAxisType &&
                graphprops.bar.XAxisType === 'string'
              ) {
                date = jsonval.DateTime;
              } else {
                let format =
                  graphprops.bar && graphprops.bar.xAxisDateFormat
                    ? graphprops.bar.xAxisDateFormat
                    : 'YYYY-MM-DD HH:mm:ss';

                if (
                  props.graphprops &&
                  props.graphprops.GraphLevelSelection &&
                  props.graphprops.GraphLevelSelection === 'dateMonthYearPicker'
                ) {
                  if (props.dayMonthYear && props.dayMonthYear.SelectionType === 'Day') {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? dayjs.utc(jsonval.DateTime).format('HH:mm')
                        : dayjs
                          .utc(jsonval.DateTime)
                          .tz(props.currentTimeZone)
                          .format('HH:mm');
                  } else if (
                    props.dayMonthYear &&
                    props.dayMonthYear.SelectionType === 'Month'
                  ) {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? dayjs.utc(jsonval.DateTime).format('DD/MM')
                        : dayjs
                          .utc(jsonval.DateTime)
                          .tz(props.currentTimeZone)
                          .format('DD/MM');
                  } else if (
                    props.dayMonthYear &&
                    props.dayMonthYear.SelectionType === 'Year'
                  ) {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? dayjs.utc(jsonval.DateTime).format('MMMM')
                        : dayjs
                          .utc(jsonval.DateTime)
                          .tz(props.currentTimeZone)
                          .format('MMMM');
                  }
                } else {
                  date =
                    graphprops && graphprops.type === 'summary'
                      ? dayjs.utc(jsonval.DateTime).format(format)
                      : dayjs.utc(jsonval.DateTime).tz(props.currentTimeZone).format(format);
                }
              }
            }
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              dates.push(jsonval.Description);
            } else {
              dates.push(date);
            }
          }
          if (tagval === jsonval.Description) {
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              values.push({
                value: jsonval.Value,
                name: jsonval.Description,
                percentage: jsonval.percentage
              });
            } else {
              values.push(jsonval.Value);
            }
          }
          return {};
        });
        if (yaxis.length > 1) {
          yaxis && Array.isArray(yaxis) &&
            yaxis.map((axis, axisindex) => {
              if (axis && axis.tags && axis.tags.indexOf(tagval) === -1) {
                let linetags =
                  props.graphprops && props.graphprops.bar ? props.graphprops.bar.tags : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map((tag) => {
                      seriesarray.push({
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        // yAxisIndex: axisindex,
                        barGap: 0,
                        emphasis: {
                          focus: 'series'
                        },
                        ...(showStack && showStack === 'true' ? { stack: 'total' } : {}),
                        label: {
                          show:
                            showLabel && (showLabel === 'true' || showLabel === true) ? true : false,
                          ...(formatted === "true" ? labelOption : {}),
                        }
                        ,
                        // label : (formatted === "true" ? labelOption :{}),
                        markPoint: {
                          data: props.graphprops.minMax
                            ? [
                              { type: 'max', name: 'Max' },
                              { type: 'min', name: 'Min' }
                            ]
                            : null
                        },
                        type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'line',
                        axisLabel: { fontSize: 15 }
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type: 'bar',
                    axisLabel: { fontSize: 15 }
                  });
                }
              }
              return {};
            });
        } else {
          let linetags = props.graphprops && props.graphprops.bar ? props.graphprops.bar.tags : [];
          if (linetags && linetags.length > 0) {
            linetags &&
              linetags.map((tag) => {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  type: legendsdata[tagindex]['name'] !== tag || gridIndex === "true" ? 'bar' : 'line',
                  axisLabel: { fontSize: 15 }
                });
                return {};
              });
          } else {
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              seriesarray = {
                axisLabel: { fontSize: 15 },
                type: 'bar',
                data: values
              };
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                barGap: 0,
                emphasis: {
                  focus: 'series'
                },
                type: 'bar',
                axisLabel: { fontSize: 15 },
                ...(showStack && showStack === 'true' ? { stack: 'Total' } : { stack: '' }),
                label: {
                  show: showLabel && (showLabel === 'true' || showLabel === true) ? true : false,
                  position: 'inside',
                  ...(formatted === "true" ? labelOption : {}),
                },
              });
            }
          }
        }

        return {};
      });
      const option = cloneDeep(getOption());
      let series = await trendLabelTranslation(seriesarray, translationCache);
      if (
        props.graphprops &&
        props.graphprops.bar &&
        props.graphprops.bar.colors &&
        props.graphprops.bar.colors.length > 0
      ) {
        option.color = [...props.graphprops.bar.colors];
      }
      if (viewType === 'horizontal') {
        option.xAxis = yaxis && Array.isArray(yaxis) ? [...yaxis] : yaxis;
        option.yAxis.data = Array.isArray(descriptionListDuplicate) && Object.keys(descriptionListDuplicate).length > 0 && descriptionListDuplicate !== null
          ? descriptionListDuplicate && { ...descriptionListDuplicate } && descriptionListDuplicate
          : { ...descriptionListDuplicate } || {};
        option.series = series && Array.isArray(series) ? [...series] : series;
      } else {
        option.xAxis.data = dates && Array.isArray(dates) ? [...dates] : dates;
        option.yAxis = Array.isArray(yaxis) && Object.keys(yaxis).length > 0 && yaxis !== null
          ? yaxis && { ...yaxis } && yaxis
          : { ...yaxis } || {};
       

        option.series = series && Array.isArray(series) ? [...series] : series;
      }
       if (props.graphprops.bar && props.graphprops.bar.YAxis) {
          const seriesDataa = addYAxisIndex(series, props.graphprops.bar);
          series = seriesDataa

        }
      if (gridIndex === "true") {
        let datesValue = dates && Array.isArray(dates) ? [...dates] : dates;
        option.xAxis = [
          { gridIndex: 0, data: datesValue },
          { gridIndex: 1, data: datesValue }
        ];

        option.yAxis = [
          { gridIndex: 0 },
          { gridIndex: 1 }
        ];
        option.dataZoom = [];
        const currentGrid = option.grid; // should be an object, not an array
        option.grid = [
          { ...currentGrid, bottom: '55%' },
          { ...currentGrid, top: '55%' }
        ];

        const tagsList = props.graphprops.bar;
        const hasTags = tagsList && Array.isArray(tagsList.tags) && tagsList.tags.length > 0;
        let dedupedArray = [];
        dedupedArray = removeDuplicateObjectsByKey(seriesarray, 'name');

        option.series = (dedupedArray || []).map(series => {
          if (hasTags && tagsList.tags.includes(series.name)) {
            return {
              ...series
            };
          }
          return {
            ...series,
            seriesLayoutBy: 'row'
          };
        });
      }
      // option.series = series && Array.isArray(series) ? [...series] : series;
      option.legend = legendsdata && Array.isArray(legendsdata) ? [...legendsdata] : legendsdata;

      setOption(option);
      setRefreshDateTime(dayjs());


    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };
  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? dayjs(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '75%', width: '100%' }}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(Bar);
